import { UseInfiniteQueryResult } from 'react-query';
import { getApiLocale } from 'modules/i18n';
import { useInfiniteQueryBase } from '../../hooks';
import {
  fetchDegreesPage,
  fetchStudiesPage,
  fetchUniversitiesPage
} from './api';
import {
  USE_DEGREES_QUERY_KEY,
  USE_STUDIES_QUERY_KEY,
  USE_UNIVERSITIES_QUERY_KEY
} from './constants';
import {
  DegreesResponse,
  StudiesResponse,
  UniversitiesResponse
} from './types';

export const useUniversitiesInfiniteQuery =
  (): UseInfiniteQueryResult<UniversitiesResponse> => {
    return useInfiniteQueryBase(
      [USE_UNIVERSITIES_QUERY_KEY],
      pageParam => {
        return fetchUniversitiesPage(
          pageParam
        ) as Promise<UniversitiesResponse | null>;
      },
      {
        entityName: 'universities'
      }
    );
  };

export const useStudiesInfiniteQuery =
  (): UseInfiniteQueryResult<StudiesResponse> => {
    return useInfiniteQueryBase(
      [USE_STUDIES_QUERY_KEY],
      pageParam => {
        const locale = getApiLocale();
        return fetchStudiesPage(
          pageParam,
          locale
        ) as Promise<StudiesResponse | null>;
      },
      {
        entityName: 'studies'
      }
    );
  };

export const useDegreesInfiniteQuery =
  (): UseInfiniteQueryResult<DegreesResponse> => {
    return useInfiniteQueryBase(
      [USE_DEGREES_QUERY_KEY],
      pageParam => {
        const locale = getApiLocale();

        return fetchDegreesPage(
          pageParam,
          locale
        ) as Promise<DegreesResponse | null>;
      },
      {
        entityName: 'degrees'
      }
    );
  };
